import React, { PropsWithChildren } from "react";
import styles from "./FakeCheckbox.module.css";

/**
 * FakeCheckbox is a component that simulates a checkbox.
 * It is used for visual representation only and does not have any functionality.
 * Checkbox event handlers are buggy in React, bubbling up to the parent component unreliably.
 * This component is used to avoid those issues.
 */
export const FakeCheckbox: React.FC<
  PropsWithChildren<{
    checked?: boolean;
    disabled?: boolean;
  }>
> = ({ checked, disabled }) => {
  return (
    <span
      className={`${styles.Checkbox} ${disabled ? styles.Disabled : ""} ${checked ? styles.Checked : ""}`}
    />
  );
};
